export const all = (state) => state.features.map
export const restaurants = (state) => all(state).restaurants
export const selected = (state) => all(state).selected

export const viewsDesktop = (state) => all(state).view.desktop

export const geolocation = (state) => all(state).geolocation
